import { Button, Col, Form, Row, Select, Spin } from "antd"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import helper from "../utils/helper";
import { setOfferData, stepperMoving } from "../stores/actions";
import { errorMessage } from "../utils/commonStringsConsts";
import { OutPutResult } from '@operations/shared';
const { Option } = Select;

export default function SelectCompanyOrPartner() {
    const offerData = useSelector((state: any) => state.actionsReducer.offerData)
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [companies, setCompanies] = useState<any[]>([])
    const [serviceGroups, setServiceGroups] = useState<any[]>([])
    const [loadingData, setLoadingData] = useState(false)
    const [errorMode, setErrorMode] = useState(false)

    useEffect(() => {
        dispatch(setOfferData({ isCompany: true, offerTypeId: null, selectedCompanyInfo: null }))
        form.setFieldsValue({ isCompany: true })
        getCompanies()
    }, [dispatch, form])

    const getCompanies = async () => {
        try {
            setLoadingData(true)
            const companiesRes: any = await helper.getCompanies();
            if (companiesRes?.status === 200) {
                setCompanies(companiesRes?.data?.data)
            } else {
                setErrorMode(true)
            }
        } catch (error) {
            setErrorMode(true)
        } finally {
            setLoadingData(false)
        }
    }

    const getServiceGroups = async () => {
        try {
            setLoadingData(true);
            const getServiceTypes: any = await helper.getServiceTypes(true);
            if (getServiceTypes?.status !== 200) {
                setErrorMode(true)
                setLoadingData(false)
                return
            }
            else {
                setServiceGroups(getServiceTypes?.data?.data?.servicesGroups);
                setLoadingData(false)
            }
        } catch (error) {
            setErrorMode(true)
            setLoadingData(false)
        }
    }

    const setOfferTypeId = async (values: any) => {
        console.log(offerData, 'offerData');
        dispatch(setOfferData({ ...offerData, offerTypeId: values.isCompany ? values.companyID : values.serviceGroupId, maxInstallmentCount: values.maxInstallmentCount }))
        dispatch(stepperMoving(1))
    }

    const dropDownSearch = (input: string, option: { children: string; }) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const changeInputs = (value: any) => {
        dispatch(setOfferData({ ...offerData, isCompany: value, offerTypeId: null, selectedCompanyInfo: null }))
        form.setFieldsValue({ isCompany: value })
        if (value) {
            getCompanies()
        } else {
            getServiceGroups()
        }
    }

    const handleCompanySelect = (companyId: number | undefined) => {
        const selectedCompany = companies.find((company: any) => company?.id === companyId)
        if (selectedCompany) {
            console.log(selectedCompany, "selectedCompany")
        }
        dispatch(setOfferData({ ...offerData, selectedCompanyInfo: selectedCompany || null }))
    }

    return (
        errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage ? errorMessage : 'Something went wrong, please refresh the page and try again'}
            btnTitle={'Refresh the page'} btnClick={helper.refreshPage} /> :
            <div className="createEarlyPayment">
                <Spin size="large" spinning={loadingData}>
                    <Form name="nest-messages" onFinish={setOfferTypeId} initialValues={{ isCompany: offerData.isCompany }} form={form}>
                        <Row className="inputsRow">
                            <Col span='12'>
                                <label>Offer For <span>*</span></label>
                                <Form.Item
                                    name="isCompany"
                                    rules={[{ required: true, message: 'Required' }]}
                                >
                                    <Select onChange={changeInputs}>
                                        <Option value={true}>Company</Option>
                                        <Option value={false}>Partner</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            {offerData.isCompany ? <Col span='12'>
                                <label>Company <span>*</span></label>
                                <Form.Item
                                    name="companyID"
                                    rules={[{ required: true, message: 'Required' }]}
                                >
                                    <Select placeholder="Select a company" showSearch allowClear
                                        onChange={handleCompanySelect}
                                        filterOption={((input, option: any) => dropDownSearch(input, option))}
                                    >
                                        {Array.isArray(companies) &&
                                            companies?.map((company: { id: number, name: string }) => <Option key={company?.id} value={company?.id} company={company}>{company?.name}</Option>)}
                                    </Select>
                                </Form.Item>
                            </Col> :
                                <Col span='12'>
                                    <label>Partner Service Groups <span>*</span></label>
                                    <Form.Item
                                        name="serviceGroupId"
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <Select placeholder="Select a service group" showSearch allowClear
                                            filterOption={((input, option: any) => dropDownSearch(input, option))}
                                        >
                                            {Array.isArray(serviceGroups) &&
                                                serviceGroups?.map((serviceGroup: { id: number, name: string }) => <Option key={serviceGroup?.id} value={serviceGroup?.id} serviceGroup={serviceGroup}>{serviceGroup?.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>}
                            <Col span='24' className="btnCol">
                                <Form.Item>
                                    <Button shape="round" type="primary" block htmlType="submit" >
                                        Next
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </div>
    )
}